export const doctor = {
	en: {
		singular: 'Retail customer',
		plural: 'Retail customers',
	},
	ar: {
		singular: 'زبون تجزئة',
		plural: 'زبائن تجزئة',
	}
};
export const pharmacy = {
	en: {
		singular: 'Wholesale customer',
		plural: 'Wholesale customers',
	},
	ar: {
		singular: 'زبون جملة',
		plural: 'زبائن جملة',
	}
};